export default [
  {
    text: "国家电网有限公司员工服务“十个不准”（服务承诺）",
    url: "/pdf/fuwuGf/国家电网有限公司员工服务“十个不准”.pdf",
  },
  {
    text: "国家电网有限公司供电服务“十项承诺”（服务承诺）",
    url: "/pdf/fuwuGf/国家电网有限公司供电服务“十项承诺”.pdf",
  },
];
